import { COLOUR_CONSTANT } from "../../utils/contants";
import {
  BuildingIcon,
  CompaniesIcon,
  ContactListIcon,
  DashboardIcon,
  EncircledPlusIcon,
  ProjectGroupIcon,
  ProjectsIcon,
  RevenueIcon,
  ClockIcon,
  UtilizationDashboardIcon,
} from "../../utils/svg-components";

export const getAppHeaderRoutes = ({
  navigate,
  userPermissions,
  isGeneralUser,
  setShowModal,
  setShowGroupModal,
  showCompanyModal,
  showContactModal,
}) => {
  return [
    {
      title: "Dashboards",
      baseUrl: "/dashboards/",
      icon: <DashboardIcon />,
      menuWidth: 200,
      options: [
        {
          title: "My Dashboard",
          value: "my-dashboard",
          icon: <DashboardIcon />,
          onClick: () => navigate("/dashboards/user-dashboard"),
        },

        ["Admin", "Supervisor", "Project Manager"].includes(
          userPermissions
        ) && {
          title: "Revenue Forecast",
          value: "revenue",
          icon: <RevenueIcon />,
          onClick: () => navigate("/dashboards/revenue-forecast"),
        },

        ["Admin", "Supervisor"].includes(userPermissions) && {
          title: "Company Utilization",
          value: "utilization-dashboard",
          icon: <UtilizationDashboardIcon />,
          onClick: () => navigate("/dashboards/utilization-dashboard"),
        },
      ],
    },

    {
      title: "Companies",
      baseUrl: "/companies/",
      icon: <BuildingIcon />,
      menuWidth: 200,
      options: [
        {
          title: "Company List",
          value: "companies",
          icon: <CompaniesIcon />,
          onClick: () => navigate("/companiesview/"),
        },
        {
          title: "Contact List",
          value: "contact-list",
          icon: <ContactListIcon />,
          onClick: () => navigate("/contactsview/"),
        },
        ...(!isGeneralUser
          ? [
              {
                title: "Create Company",
                value: "create-company",
                onClick: () => showCompanyModal(true),
                icon: <EncircledPlusIcon />,
                backgroundColor: COLOUR_CONSTANT.theme.green.light,
              },
              {
                title: "Create Contact",
                value: "create-company-contact",
                onClick: () => showContactModal(true),
                icon: <EncircledPlusIcon />,
                backgroundColor: COLOUR_CONSTANT.theme.green.dark,
              },
            ]
          : []),
      ],
    },
    {
      title: "Projects",
      baseUrl: "/projectsview/",
      icon: <ProjectsIcon />,
      menuWidth: 200,
      options: [
        {
          title: "Project List",
          value: "project-list",
          icon: <ProjectsIcon />,
          onClick: () => navigate("/projectsview/"),
        },
        {
          title: "Project Group List",
          value: "project-list",
          icon: <ProjectGroupIcon />,
          onClick: () => navigate("/projectsview/projectsGroupView"),
        },
        ...(!isGeneralUser
          ? [
              {
                title: "Create Project",
                value: "create-project",
                onClick: () => setShowModal(true),
                icon: <EncircledPlusIcon />,
                backgroundColor: COLOUR_CONSTANT.theme.green.light,
              },
            ]
          : []),
        ...(!isGeneralUser
          ? [
              {
                title: "Create Project Group",
                value: "create-project-group",
                onClick: () => setShowGroupModal(true),
                icon: <EncircledPlusIcon />,
                backgroundColor: COLOUR_CONSTANT.theme.green.dark,
              },
            ]
          : []),
      ],
    },

    // {
    //   title: "Billing",
    //   baseUrl: "/billing/",
    //   icon: <BillingIcon />,
    //   menuWidth: 150,
    //   options: [
    //     {
    //       title: "Invoice List",
    //       value: "invoice-list",
    //       onClick: () => navigate("/billing/invoicelist"),
    //     },
    //     {
    //       title: "Purchase List",
    //       value: "purchase-list",
    //       onClick: () => navigate("/billing/purchase-list"),
    //     },
    //     {
    //       title: "Create Invoice",
    //       value: "create-invoice",
    //       onClick: () => {},
    //       backgroundColor: COLOUR_CONSTANT.theme.green.light,
    //     },
    //     {
    //       title: "Create Purchase",
    //       value: "create-purchase",
    //       onClick: () => {},
    //       backgroundColor: COLOUR_CONSTANT.theme.green.dark,
    //     },
    //   ],
    // },
    {
      title: "Time",
      baseUrl: "/time-tracker/",
      icon: <ClockIcon />,
      menuWidth: 200,
      options: [
        {
          title: "Weekly Timesheet",
          value: "timesheet",
          icon: <ClockIcon />,
          onClick: () => navigate("/time-tracker/"),
        },
      ],
    },
  ];
};
